import { authActionTypes } from '../types';
import { UserRoleReducer } from 'src/interfaces/authReduxShapes';

const initialState: UserRoleReducer = {
  role: null
};

export default (state = initialState, { type, payload }: { type: string; payload }): UserRoleReducer => {
  switch (type) {
    case authActionTypes.SET_USER_ROLE: {
      return {
        role: payload
      };
    }

    default:
      return state;
  }
};
